import React from "react";
import {
    BTCDarkIcon,
    BTCLightIcon,
    EVMDarkIcon,
    EVMLightIcon,
    SOLDarkIcon,
    SOLLightIcon, TonDarkIcon, TonLightIcon,
    TRXDarkIcon, TRXLightIcon
} from "../assets/icon";
import {useDownMd} from "./useLayout";
import {WalletType} from "../types";
export const DEFAULT_WALLET_METHODS:WalletType[] = ["evm", 'sol', 'btc', 'tron', 'ton']
export const WALLET_METHODS:WalletType[] = ["evm", 'sol', 'btc', 'tron', 'ton']
export function useWalletConfig(){
    const isDownMd = useDownMd()
    const walletMap: {
        [key: string]: {
            icon: React.ReactNode,
            activeIcon: React.ReactNode,
            name: string,
            method: WalletType,
        }
    } = {
        evm: {
            icon: <EVMDarkIcon size={isDownMd ? 36 : 40}/>,
            activeIcon: <EVMLightIcon size={isDownMd ? 36 : 40}/>,
            name: "EVM",
            method: 'evm'
        },
        sol: {
            icon: <SOLDarkIcon size={isDownMd ? 36 : 40}/>,
            activeIcon: <SOLLightIcon size={isDownMd ? 36 : 40}/>,
            name: "SOL",
            method: 'sol'
        },
        btc: {
            icon: <BTCDarkIcon size={isDownMd ? 36 : 40}/>,
            activeIcon: <BTCLightIcon size={isDownMd ? 36 : 40}/>,
            name: "BTC",
            method: 'btc'
        },
        tron: {
            icon: <TRXDarkIcon size={isDownMd ? 36 : 40}/>,
            activeIcon: <TRXLightIcon size={isDownMd ? 36 : 40}/>,
            name: "TRON",
            method: 'tron'
        },
        ton: {
            icon: <TonDarkIcon size={isDownMd ? 36 : 40}/>,
            activeIcon: <TonLightIcon size={isDownMd ? 36 : 40}/>,
            name: "TON",
            method: 'ton'
        }
    }

    return {
        walletMap
    }
}